export function getDefaultRoute(hasPermission: (p: string) => boolean): string {
  if (hasPermission('analytics:read')) return '/v2/analytics';
  if (hasPermission('moderation:read')) return '/v2/moderation';
  return '/access-denied';
}
